import type { AudienceSegmentSearchInputDescriptor } from '@openx/types/gqlTypes.ts';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext.tsx';

export const useAudienceSearchFetch = (input: AudienceSegmentSearchInputDescriptor) => {
  const { useDealPromptAudienceSearchFetch } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceSearch } = useDealPromptAudienceSearchFetch(input);

  return fetchDealPromptAudienceSearch;
};
